import {
  IntakeFormsActionTypes,
  IntakeFormsState,
  INSERT_INTAKE_FORMS,
  SET_FORM_STATE_UPDATED,
  SET_FORM_STATE_REQUEST,
  SET_RESPONSE_STATE_REQUEST,
  SET_RESPONSE_STATE_ADDED,
  SET_RESPONSE_STATE_UPDATED,
  SET_RESPONSE_STATE_FAIL,
  SET_RESPONSE_PAGE_STATE,
  SET_FORM_CREATE_PANEL,
  SET_USER_RESPONSE_STATE_ADDED,
  SET_USER_RESPONSE_STATE_FAIL,
  SET_USER_RESPONSE_STATE_REQUEST,
  DELETE_INTAKE_FORM_SUCCESS,
  IntakeForm,
  UPDATE_INTAKE_FORMS,
  DELETE_RESPONSES_SUCCESS,
  IntakeFormResponse,
} from './types';

const initialState: IntakeFormsState = {
  items: [],
  responses: [],
  isFormLoading: false,
  isFormLoaded: false,
  isResponseLoading: false,
  isResponseLoaded: false,
  selectedResponseId: '',
  selectedUserResponses: [],
  formCreatePanel: { data: null },
};

const intakeFormsReducer = (
  // eslint-disable-next-line default-param-last
  state = initialState,
  action: IntakeFormsActionTypes,
) => {
  switch (action.type) {
    case SET_FORM_STATE_REQUEST: {
      return {
        ...state,
        isFormLoading: true,
      };
    }

    case INSERT_INTAKE_FORMS: {
      const { payload } = action;
      const filteredPayloadItems = payload.filter(
        pItem => !state.items.some(item => item.id === pItem.id),
      );
      return {
        ...state,
        items: [...state.items, ...filteredPayloadItems],
        isFormLoaded: true,
        isFormLoading: false,
      };
    }

    case SET_FORM_STATE_UPDATED: {
      const { payload } = action;
      return {
        ...state,
        isFormLoading: false,
        isFormLoaded: true,
        items: state.items.map(t => {
          if (t.id === payload.id) {
            return {
              ...t,
              ...payload,
              additionalFields: {
                ...t.additionalFields,
                ...payload.additionalFields,
              },
            };
          }
          return t;
        }),
      };
    }
    case SET_USER_RESPONSE_STATE_REQUEST:
    case SET_RESPONSE_STATE_REQUEST: {
      return {
        ...state,
        isResponseLoading: true,
        isResponseLoaded: false,
      };
    }
    case SET_USER_RESPONSE_STATE_FAIL:
    case SET_RESPONSE_STATE_FAIL: {
      return {
        ...state,
        isResponseLoading: false,
        isResponseLoaded: false,
      };
    }

    case SET_RESPONSE_STATE_ADDED: {
      const newResponseIds = action.payload.map(fr => fr.id);
      const unchangedResponses =
        state.responses?.filter(fr => !newResponseIds.includes(fr.id)) || [];

      return {
        ...state,
        isResponseLoading: false,
        isResponseLoaded: true,
        responses: state.responses
          ? [...unchangedResponses, ...action.payload]
          : action.payload,
      };
    }

    case SET_RESPONSE_STATE_UPDATED: {
      const updatedResponse = action.payload;
      return {
        ...state,
        isResponseLoading: false,
        isResponseLoaded: true,
        responses: state.responses.map(res =>
          res.id === updatedResponse.id ? { ...res, ...action.payload } : res,
        ),
      };
    }

    case SET_RESPONSE_PAGE_STATE: {
      return {
        ...state,
        ...action.payload,
      };
    }

    case SET_FORM_CREATE_PANEL: {
      return {
        ...state,
        formCreatePanel: action.payload,
      };
    }

    case SET_USER_RESPONSE_STATE_ADDED: {
      return {
        ...state,
        isResponseLoading: false,
        selectedUserResponses: action.payload,
      };
    }

    case DELETE_INTAKE_FORM_SUCCESS: {
      const { payload: ids } = action;
      return {
        ...state,
        items: state.items.filter((f: IntakeForm) => !ids.includes(f.id)),
      };
    }

    case UPDATE_INTAKE_FORMS: {
      const { payload: formsToUpdate } = action;

      const otherForms = state.items.filter(
        (form: IntakeForm) => !formsToUpdate.map(f => f.id).includes(form.id),
      );

      const newChannels = formsToUpdate.concat(otherForms);

      return {
        ...state,
        items: newChannels,
      };
    }

    case DELETE_RESPONSES_SUCCESS: {
      const { payload: ids } = action;
      return {
        ...state,
        responses: state.responses.filter(
          (f: IntakeFormResponse) => !ids.includes(f.id),
        ),
      };
    }

    default:
      return state;
  }
};

export default intakeFormsReducer;
